import { useMutation } from '@tanstack/react-query';
import { downloadSummaryReport } from '../BulkProvisioningApi/bulkProvisioningApi.ts';
import { useState } from 'react';
import { AlertColor } from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';

export type Message = {
  title: string;
  subtitle: string;
  severity: AlertColor;
};

export const useDownloadSummaryReport = () => {
  const [message, setMessage] = useState<Message>();
  const { t } = useTranslation();

  const mutation = useMutation({
    mutationFn: (date: string) => {
      return downloadSummaryReport(date);
    },
    onSuccess: () => {
      setMessage({
        title: 'Generating error report',
        subtitle: t('bulkProvisioning.errorReportSuccessMessage'),
        severity: 'success',
      });
    },
    onError: () => {
      setMessage({
        title: 'Report failed!',
        subtitle: t('bulkProvisioning.errorReportFailureMessage'),
        severity: 'error',
      });
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
    message,
    setMessage,
  };
};
